import { useCallback, useState } from "react";
import { showKelas } from "../../api";
import { Modal } from "react-bootstrap";
import { useRecoilValue } from "recoil";
import { tokenState } from "../../storages/auth";

function ModalPengajaran({ id }) {

    const token = useRecoilValue(tokenState);
    const [modal, setModal] = useState(false);
    const [items, setItems] = useState({});
    const [loading, setLoading] = useState(true);

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const res = await showKelas(id, token);
            setItems(res.data);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }, [id, token]);

    const handleOpen = () => {
        fetchData();
        setModal(true);
    };

    const handleClose = () => {
        setModal(false);
        setItems({});
    };

    return (
        <>
            <button onClick={handleOpen} className="btn btn-sm btn-success-2"><i className="fa fa-fw fa-eye me-1"></i>Pertemuan</button>

            <Modal
                show={modal}
                onHide={handleClose}
                size="xl"
                centered
                contentClassName="border-0 rounded-5"
            >
                <Modal.Body className='bg-gradient-primary rounded-4 p-0'>
                    <div className="score-background rounded-top-4 shadow-nice p-4">
                        <div>
                            <h5 className="my-0 text-warning fst-italic fw-semibold fs-3">
                                List Pertemuan {!loading ? items.kode : <div className='skeleton' style={{ width: '12rem', height: '24px' }} />}
                            </h5>
                        </div>
                    </div>
                    <div className="row pt-4 g-0 mx-3">
                        {items.pengajaran ? items.pengajaran.map((i, index) => {
                            return (
                                <div key={index} className="col-lg-6 g-2">
                                    <div className="border border-silver text-white rounded-3 p-3">
                                        <h5 className="mb-1 fs-6">Pertemuan {i.pertemuan ? i.pertemuan : '-'}</h5>
                                        <p className="text-sm">Tanggal : {i.tanggal ? i.tanggal : '-'}</p>
                                        <p className="mb-1 text-sm">Pembahasan :</p>
                                        <p>{i.pembahasan ? i.pembahasan : '-'}</p>
                                        <div className="mb-1">
                                            <p className="mb-1 text-sm">Link Meet :</p>
                                            {i.link_meet ? (
                                                <button
                                                    className="btn btn-sm btn-primary-2 rounded-5 shadow text-sm px-3 py-custom-1"
                                                    onClick={() =>
                                                        window.open(
                                                            i.link_meet
                                                        )
                                                    }
                                                >
                                                    <i className="fa fa-fw fa-link me-2 text-sm" />
                                                    buka disini
                                                </button>
                                            ) : '-'}
                                        </div>
                                        <div className="mb-1">
                                            <p className="mb-1 text-sm">Link Materi :</p>
                                            {i.link_materi ? (
                                                <button
                                                    className="btn btn-sm btn-primary-2 rounded-5 shadow text-sm px-3 py-custom-1"
                                                    onClick={() =>
                                                        window.open(
                                                            i.link_materi
                                                        )
                                                    }
                                                >
                                                    <i className="fa fa-fw fa-link me-2 text-sm" />
                                                    buka disini
                                                </button>
                                            ) : '-'}
                                        </div>
                                    </div>
                                </div>
                            )
                        }) : (
                            '-'
                        )}
                    </div>
                    <div className="btn-group mobile-justify-center px-4 py-4">
                        <button type="button" onClick={handleClose} className="btn btn-sm btn-dark">
                            Kembali
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalPengajaran